import BaseController from "./BaseController";

/**
 * @namespace ang.order_portal.controller
 */
export default class Impressum extends BaseController {
	public onInit(): void {
		// No view-specific behavior is required yet.
	}
}
